var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-row",
                [
                  _c("b-skeleton", {
                    staticClass: "mx-5 my-3",
                    attrs: { width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-skeleton", {
                    staticClass: "mx-5 my-3",
                    attrs: { width: "100%", height: "10rem" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-skeleton", {
                    staticClass: "mx-5 my-3",
                    attrs: { width: "100%", height: "10rem" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-skeleton", {
                    staticClass: "mx-5 my-3",
                    attrs: { width: "100%", height: "10rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }